import type { HTMLAttributes } from 'react'

const baseClasses =
  'font-mono text-[16px] tracking-[5px] text-carolina-dark dark:text-carolina'

type SectionLabelProps = HTMLAttributes<HTMLParagraphElement>

export function SectionLabel({ className = '', ...props }: SectionLabelProps) {
  return (
    <p
      data-component="SectionLabel"
      className={`${baseClasses} ${className}`}
      {...props}
    />
  )
}
